import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccessService } from './services/access.service';

/**
 * Prevent access to routes if permissions is not present.
 * @export
 * @class ViewsGuard
 * @implements {CanActivate}
 */

@Injectable({
  providedIn: 'root'
})
export class AccessGuard {
  constructor(
    public accessService: AccessService
  ) { }

  canActivate(next: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    let tabName = next.data.name.replaceAll(' ', '');
    let shouldAccessTab = false;

    if (tabName) {
      shouldAccessTab = this.accessService.shouldAccessTab(tabName);
      return shouldAccessTab;
    }

    return false;
  }
}
